import React, { useEffect, useState } from "react";
import {
  useHistory,
  Route,
  Switch,
  Redirect,
  useLocation
} from "react-router-dom";
import NavigationBar from "./containers/NavigationBar/NavigationBar";
import Sidebar from "./containers/SideBar/Sidebar";
import InvalidPermission from "./pages/InvalidPermission";
import { Security, SecureRoute, LoginCallback } from "@okta/okta-react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.scss";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import { authService } from "./services/AuthService";
import DOCOnlinePage from "./pages/DOCOnline/DOCOnlinePage";
import { useGeneralContext } from "./pages/General/Context";
import DOCOnlineError from "./pages/DOCOnline/DOCOnlineError";
import DOCOnlineEdit from "./pages/Interview/EditDocOnline/DOCOnlineEdit";
import { ConfigSettings } from "./config/Config";
import { routes } from "./Routes";
const configSettings = ConfigSettings();
const oktaAuth = new OktaAuth(configSettings.oidc);

const AppRouter = () => {
  const urls = ["doconline", "consultant"];
  const objectRouter = useLocation().pathname;

  const { userInformation, setUserInformation } = useGeneralContext();
  const history = useHistory();
  useEffect(async () => {
    let isNotDocOnline = !urls.some((t) =>
      objectRouter.toLocaleLowerCase().includes(t)
    );
    let isOktaAuth = await oktaAuth.isAuthenticated();
    if (isNotDocOnline && !isOktaAuth) {
      await oktaAuth.signInWithRedirect(objectRouter);
    }
  }, []);

  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    let tokenAcess = await oktaAuth.getAccessToken();
    if (!tokenAcess) await oktaAuth.signInWithRedirect(objectRouter);
    else {
      authService.login(tokenAcess).then((data) => {
        if (!data) {
        } else {
          setUserInformation(data);
          history.replace(toRelativeUrl(originalUri, window.location.origin));
        }
      });
    }
  };

  function CheckUrl() {
    return !urls.some((t) => objectRouter.toLocaleLowerCase().includes(t));
  }

  return (
    <>
      <ToastContainer autoClose={3000} hideProgressBar />
      <Route path="/doconline/:token" component={DOCOnlinePage} />
      <Route exact path="/doconline/" component={DOCOnlineError} />
      <Route
        path="/consultant/docedit/:company/:languageCode/:docOnlineticket"
        component={DOCOnlineEdit}
      />

      {CheckUrl() && (
        <>
          {" "}
          <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
            <div className="main scale-content">
              <NavigationBar userInfo={userInformation} />
              <div className="content">
                <Sidebar />
                <div className="main-content">
                  <Switch>
                    {userInformation.permissions &&
                      routes.map((route, index) => {
                        for (let perm of route.permissions)
                          if (!userInformation.permissions[perm]) return null;

                        return route.exact ? (
                          <SecureRoute
                            key={index}
                            exact
                            path={route.path}
                            component={route.handler}
                          />
                        ) : (
                          <SecureRoute
                            path={route.path}
                            component={route.handler}
                          />
                        );
                      })}

                    <Route path="/login/callback" component={LoginCallback} />
                  </Switch>
                </div>
              </div>{" "}
            </div>
          </Security>
        </>
      )}
    </>
  );
};

export default AppRouter;
